import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import AuthCode from "react-auth-code-input";
import InitialSetup from "./InitialSetup";

import { signIn2FA, signoutUser } from "../../../actions/UserActions";

import defaultBg from "../../../assets/backgrounds/bloom.jpg";
import defaultLogo from "../../../assets/logos/Logo-Oasis.svg";

class TwoFAuth extends Component {
  state = {
    fieldValues: {},
    background: this.props.customBgImage || defaultBg,
    allDigitsEntered: false,
    totpRequiresConfig: false,
  };

  handleChange = (field, value) => {
    this.setState({
      fieldValues: {
        ...this.state.fieldValues,
        [field]: value,
      },
    });
    this.setState({ allDigitsEntered: value.length === 6 });
  };

  updateSetupCompleteAndVerified = () => {
    this.setState({
      totpRequiresConfig: false,
    });
  };

  componentDidMount() {
    this.setState({
      totpRequiresConfig: this.props.User.twoFATOTPRequiresConfiguration,
    });
  }

  render() {
    const { _, User, signoutUser, signIn2FA } = this.props;
    if (User && !User.redirectTo2FA) {
      return <Redirect to="/Login" />;
    }

    const authType = User.twoFAuthType;

    // 1 = Email
    // 2 = One-time Password

    return (
      <>
        {this.state.totpRequiresConfig && (
          <InitialSetup
            updateSetupCompleteAndVerified={this.updateSetupCompleteAndVerified}
            signOut={signoutUser}
            _={_}
          />
        )}
        {!this.state.totpRequiresConfig && (
          <div className={"login-screen forgot-password"}>
            <div className="login-screen-form-wrapper">
              <>
                <div>
                  <img
                    src={defaultLogo}
                    alt={_.Logo}
                    className="login-screen-logo"
                  />
                  <h3>
                    {authType == 1
                      ? _.TwoFAuth.MessageForEmailCode
                      : _.TwoFAuth.MessageForTOTPCode}
                  </h3>
                </div>
                <form className="twoFA-screen-form">
                  <div className="twoFA-instruction-text">
                    {authType == 1
                      ? _.TwoFAuth.CodeLabelPromptEmail
                      : _.TwoFAuth.CodeLabelPromptTOTP}{" "}
                    <span className="required" />
                  </div>
                  <div>
                    <AuthCode
                      containerClassName="twoFA-six-digit-input-container"
                      inputClassName="twoFA-six-digit-input-boxes"
                      allowedCharacters="numeric"
                      length={6}
                      onChange={(e) =>
                        this.handleChange("twoFactorAuthCode", e)
                      }
                    />
                  </div>
                  <div>
                    <button
                      type="submit"
                      className="btn btn-themed form-control"
                      disabled={!this.state.allDigitsEntered}
                      onClick={(e) => {
                        e.preventDefault();
                        signIn2FA({ ...this.state.fieldValues });
                      }}
                    >
                      {_.TwoFAuth.Confirm}
                    </button>
                  </div>
                </form>
                <div>
                  <p className="login-screen-or">{_.Or}</p>
                  <p className="cancel-link">
                    <a href="#" onClick={() => signoutUser()}>
                      {_.TwoFAuth.CancelLogin}
                    </a>
                  </p>

                  <p className="login-screen-footer-copyright">
                    {_.FooterCopyright}
                  </p>
                </div>
              </>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => state;
const mapActionsToProps = {
  signIn2FA,
  signoutUser,
};
export default connect(mapStateToProps, mapActionsToProps)(TwoFAuth);
